import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subject-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalHeaderComponent,
    LoaderComponent
  ],
  templateUrl: './subject-form.component.html',
  styleUrl: './subject-form.component.scss'
})
export class SubjectFormComponent implements OnChanges {
  @Input() item: any = {};
  @Input() modalInstance: any = null;

  modalTitle: string = 'Vak toevoegen';
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  modalStyle: boolean = false;

  constructor(
    private apiService: ApiService,
    public activeModal: NgbActiveModal
  ) {
    this.item = {};
  }

  ngOnChanges(changes: any) {
    this.loading = true;
    this.item = {};

    this.errorMessage = {};
    this.errors = {};
    this.getItem();
  }

  afterSave() {
    this.activeModal.close(true);
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    let method: string = 'put';
    if (!this.item['id'] || this.item['id'] === '') {
      return this.apiService.post('/office/subjects', this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      return this.apiService.put('/office/subjects/' + this.item['id'], this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    self.afterSave();
    setTimeout(function () {
      self.loading = false;
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  getItem() {
    let itemId = this.item['id'];
    let self = this;

    self.reset();
    if (itemId === '') {
      return;
    }
    return this.apiService.get('/office/subjects/' + itemId).then(function (response: any) {
      self.item = response;
      if (self.item['id']) {
        self.modalTitle = 'Wijzig vak';
      } else {
        self.modalTitle = 'Vak toevoegen';
      }
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
